module.exports = "pegasus/assets/themelp1/creative/104.png";